import { useAgentForceIntegration } from '~/composables/integrations/useAgentForceIntegration'
import { useFacebookIntegration } from '~/composables/integrations/useFacebookIntegration'
import { useGoogleTagManagerIntegration } from '~/composables/integrations/useGoogleTagManagerIntegration'
import { useGoogleAnalyticsIntegration } from '~/composables/integrations/useGoogleAnalyticsIntegration'

export const useIntegrations = () => {
  const logger = useLogger('integrations')

  const integrationMap: Record<string, () => void> = {
    agentforce: useAgentForceIntegration,
    facebook: useFacebookIntegration,
    googleTagManager: useGoogleTagManagerIntegration,
    googleAnalytics: useGoogleAnalyticsIntegration,
  }

  const init = (): void => {
    Object.keys(integrationMap).forEach((key) => {
      if (key in integrationMap) {
        const callback = integrationMap[key]

        logger.info(`Integration ${key}`)

        if (typeof callback === 'function') {
          try {
            callback()
          }
          catch (ex: unknown) {
            logger.error(String(ex))
          }
        }
        else {
          logger.error(`Integration ${key} is not a function`)
        }
      }
      else {
        logger.error(`Integration ${key} not found`)
      }
    })
  }

  return {
    init,
  }
}
